import React, { Component } from 'react';


import "./Header.css";
import PropTypes from "prop-types";
import MenuIcon from '@material-ui/icons/Menu';
import {IconButton, MenuItem, Tooltip, Typography} from "@material-ui/core";
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { showingMenuItemsSelector } from "../../redux/selectors/global";
import withShipment from "../../withShipment";
import { hideMenuItems, showMenuItems } from "../../redux/actions/global";
import { AccountCircle } from "@material-ui/icons";
import Drawer from "@material-ui/core/Drawer";
import LeftMenu from '../leftmenu/LeftMenu';
import Alerts from "../alerts/Alerts";
import {ClickAwayListener, MenuList} from "@mui/material";
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

const beenexaLogo = `${process.env.PUBLIC_URL}/logo.png`;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingProfileDropdown: false,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
    };
    this.anchorRef = React.createRef();
    this.prevOpen = React.createRef();
    this.mobileMq = window.matchMedia('(max-width: 800px)');
  }

  componentDidMount() {
    // Keep the mobile drawer/desktop-menu split in sync with viewport width.
    // The previous static snapshot would mis-render after a rotate/resize.
    this.handleViewportChange = (e) => this.setState({ isMobile: e.matches });
    if (this.mobileMq.addEventListener) {
      this.mobileMq.addEventListener('change', this.handleViewportChange);
    } else if (this.mobileMq.addListener) {
      this.mobileMq.addListener(this.handleViewportChange);
    }
  }

  componentWillUnmount() {
    if (this.mobileMq && this.handleViewportChange) {
      if (this.mobileMq.removeEventListener) {
        this.mobileMq.removeEventListener('change', this.handleViewportChange);
      } else if (this.mobileMq.removeListener) {
        this.mobileMq.removeListener(this.handleViewportChange);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {


      if (prevState.showingProfileDropdown !== this.state.showingProfileDropdown) {
          if (
            this.prevOpen.current === true &&
            this.state.showingProfileDropdown === false
          ) {
            this.anchorRef.current.focus();
          }
      this.prevOpen.current = this.state.showingProfileDropdown;
     }


  }


  handleMenuBarToggle = () => {
    const menuOpen = this.props.showingMenuItems;
    menuOpen ? this.props.hideMenuItems() : this.props.showMenuItems();
  };

  handleProfileDropdownOpen = () => {
    this.setState({
      showingProfileDropdown: true,
    });
  };

  handleProfileDropdownClose = (e) => {
    if (this.anchorRef.current && this.anchorRef.current.contains(e.target)) {
      return;
    }
    this.setState({
      showingProfileDropdown: false,
    });
  };


  render() {
    return (
      <nav className="navbar sticky-top navbar-dark  top-nav">
          <div className="top-nav">
              <div className="menu-toggle-name">
                  <IconButton onClick={this.handleMenuBarToggle}>
                      <MenuIcon color="secondary"/>
                  </IconButton>
                  <a className="navbar-brand brand-with-logo" href={"/"}>
                      <img src={beenexaLogo} alt="BeeNexa" className="brand-logo" />
                      <span className="brand-name">BeeNexa</span>
                  </a>
              </div>


              {this.state.isMobile && (
                  <Drawer
                      anchor="left"
                      open={this.props.showingMenuItems}
                      onClose={this.props.hideMenuItems}
                      className="menu-drawer"
                      transitionDuration={{enter: 300, exit: 200}}
                      ModalProps={{
                          keepMounted: true, // Improves performance
                      }}
                  >
                      <div className="drawer-container">
                          {/* Drawer Header */}
                          <div className="drawer-header">
                              <Typography
                                  variant="h6"
                                  className="drawer-header-text drawer-header-text-with-logo"
                                  style={{color: 'white'}}
                              >
                                  <img src={beenexaLogo} alt="BeeNexa" className="drawer-header-logo" />
                                  BeeNexa
                              </Typography>
                              <div className="drawer-header-close-icon">
                                  <Tooltip title="Close">
                                      <IconButton
                                          aria-label="close"
                                          onClick={this.props.hideMenuItems}
                                          className="close-icon-button"
                                      >
                                          <DoubleArrowIcon
                                              style={{color: 'white', marginRight: '8px'}}
                                          />
                                      </IconButton>
                                  </Tooltip>
                              </div>
                          </div>


                          <LeftMenu isDrawer={true} closeDrawer={this.props.hideMenuItems} routes={this.props.routes} userRoutes={this.props.userRoutes} />
                      </div>
                  </Drawer>
              )}

              <div className="alerts-component-logout">
                  <Alerts/>
                  <Tooltip title={this.props.email} placement={"down"}>
                      <IconButton
                          ref={this.anchorRef}
                          aria-label='delete'
                          onClick={this.handleProfileDropdownOpen}

                      >
                          <AccountCircle color='secondary' variant='outlined' fontSize='large'/>
                      </IconButton>
                  </Tooltip>

                  <Popper open={this.state.showingProfileDropdown} anchorEl={this.anchorRef.current} role={undefined}
                          transition disablePortal>
                      {({TransitionProps, placement}) => (
                          <Grow
                              {...TransitionProps}
                              style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}
                          >
                              <Paper>
                                  <ClickAwayListener onClickAway={this.handleProfileDropdownClose}>
                                      <MenuList autoFocusItem={this.state.showingProfileDropdown} id="menu-list-grow">
                                          <MenuItem onClick={this.props.logout}>Logout</MenuItem>
                                      </MenuList>
                                  </ClickAwayListener>
                              </Paper>
                          </Grow>
                      )}
                  </Popper>
              </div>

          </div>
      </nav>
    );
  }
}

Header.propTypes = {
    logout: PropTypes.func,
    showingMenuItems: PropTypes.bool
}

Header.defaultProps = {
    logout: () => {},
    showingMenuItems: false
}

const mapStateToProps = (state) => ({
    showingMenuItems: showingMenuItemsSelector(state),
})

const actionCreators = {
    showMenuItems,
    hideMenuItems,
}

export default withShipment({
    mapStateToProps,
    actionCreators
}, Header);